import React from "react";
import { useSelector } from "react-redux";
import { RiUser3Line } from "react-icons/ri";

/**
 * User Profile Component
 * Displays admin user information and avatar
 */
const UserProfile = () => {
  const adminUser = useSelector((state) => state.adminAuth.user);

  return (
    <div className="flex items-center space-x-3 pl-4 border-l border-gray-200">
      <div className="text-right hidden sm:block">
        <p className="text-sm font-medium text-gray-800">
          {adminUser?.name || "Admin User"}
        </p>
        <p className="text-xs text-gray-500">Administrator</p>
      </div>
      <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-semibold">
        {adminUser?.name?.[0]?.toUpperCase() || (
          <RiUser3Line className="text-lg" />
        )}
      </div>
    </div>
  );
};

export default UserProfile;
